import * as STATUS from './statusCodes'
import bus from '../plugins/bus'
import router from '../router/index'
import store from '../store/index'
import { datadogLogs } from '@datadog/browser-logs'

export const handleSuccess = (response) => {
  return Promise.resolve(response)
}

export const handleError = (error) => {
  switch (error.response.status) {
    case STATUS.TOKEN_EXPIRED:
      store.dispatch('report/getExpiredReportAgentDetails', store.state.report.token)
      return Promise.reject(new Error('Report Expired'))

    case STATUS.NOT_FOUND:
      router.push('/not-found')
      bus.emit('notFound')
      return Promise.reject(new Error('Report not found'))

    case STATUS._TIMEOUT || STATUS.SERVER_ERROR || STATUS.FORBIDDEN || STATUS.BAD_REQUEST || STATUS.NOT_AUTHORIZED || STATUS.UNPROCESSABLE_ENTITY:
      bus.emit('sessionTimeout')
      return Promise.reject(new Error('Something went wrong'))

    default:
      return Promise.reject(error)
  }
}

export const useDatadog = config => {
  datadogLogs.setGlobalContext({
    env: process.env.VUE_APP_MODE,
    lastRequestId: config.headers['X-Request-Id'],
  })
  return config
}
